import {
	Component,
	EventEmitter,
	OnInit,
	Output,
	ChangeDetectionStrategy,
} from "@angular/core"
import { COMMON_IMPORTS } from "@app/common-imports"
import { ModalWrapComponent } from "@app/modal-wrap/modal-wrap.component"
import { Modalable } from "@app/Modalable"
import { PrivacyComponent } from "@app/privacy/privacy.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { BtnExtComponent } from "@app/utils/utils.component"

@Component({
	selector: "app-terms",
	imports: [
		COMMON_IMPORTS,
		BtnExtComponent,
		LangValPipe,
		ModalWrapComponent,
		PrivacyComponent,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<div
			style="padding: 50px 3%; font-size: 14px"
			dir="rtl"
		>
			<p align="center">
				<strong><u>תנאי שימוש באתר האינטרנט </u></strong>
				<strong><u>My-Cliniq</u></strong>
				<strong><u></u></strong>
			</p>

			<p dir="ltr">אוגוסט 2026</p>
			<p class="p-margins">
				תנאי הסכם זה ("התנאים" ו/או "ההסכם") הם התנאים המחייבים שיחולו על השימוש
				בתוכנת מי קליניק ("התוכנה" או "המערכת") ומהווים הסכם משפטי מחייב בין
				המשתמש בתוכנה (להלן "המשתמש") לבין חברת ד"ר עמי אבני בע"מ, ח.פ.
				513350728 ("החברה"), שהינה בעלת הזכויות בתוכנה, כולל מנהליה, עובדיה,
				בעלי מניותיה, נותני שירות, מי שבא במקומה וכל מי מטעמה.
			</p>
			<p class="p-margins">
				"משתמש" בהסכם זה, לרבות אדם, תאגיד, עמותה, או כל ארגון אחר ו/או מי
				מטעמם, לרבות ולא רק, מנהלים, משתמש ראשי (כמפורט להלן), משתמשים נוספים
				(כמפורט לעיל), עובדים, נותני שירות, מטופלים, גולשים מזדמנים, ו/או מי
				שניגש דרכם למערכת, מכל סיבה שהיא, בתשלום ולא בתשלום.
			</p>
			<p class="p-margins">
				על המשתמש לקרוא תנאים אלה ואת מדיניות הפרטיות, בעיון רב לפני הרשמה
				לתוכנה ושימוש בה. בסימון התיבה במסגרת תהליך ההרשמה ו/או בשימוש במערכת
				המשתמש מאשר כי קרא, הבין, מסכים ומתחייב לפעול לפי כללים אלה. לא ניתן
				להשתמש במערכת ללא סימון התיבה ואישור תנאי השימוש. משתמש שאינו מסכים
				לתנאים, כולם או חלקם, אינו רשאי להשתמש במערכת, או בכל חלק שלה, לכל מטרה
				שהיא. גם לא לתקופת ניסיון, בין אם שילם או לא.
			</p>
			<p class="p-margins">
				משתמש הנרשם בשם תאגיד ו/או עמותה ו/או ארגון אחר, מצהיר בעצם הרשמתו שהוא
				מורשה מטעמם לאשר את תנאי השימוש ולהירשם בשמם. בנוסף, באחריותו ובאחריות
				התאגיד ו/או העמותה ו/או הארגון לוודא כי תנאי השימוש עומדים בכל החוקים,
				התקנות והכללים הרלוונטיים שחלים עליהם, לצד הסכמה שזכות הגישה למערכת ו/או
				לשירותים הכלולים בה מותנית בהסכמה של כל משתמש בארגון לתנאים אלה, ולכך
				שגישתם למערכת עלולה להישלל מהם במקרים בהם הייתה הפרה של תנאים אלה ו/או
				השימוש במערכת אסור עליהם מכל סיבה שהיא, ולא תהיה להם כל טענה, תביעה ו/או
				דרישה כלפי החברה.
			</p>
			<p class="p-margins">
				ככל שהארגון אינו רשום ו/או מאוגד, המשתתף שנרשם מצהיר שהוא מצטרף בהסכמת
				כל חברי הארגון ושהם מכירים את כל תנאי הסכם זה, לרבות ולא רק שאחריות,
				הסכמות וחבויות לפי ההסכם יחולו עליו ועל כל אחד מחברי הארגון ביחד ולחוד.
			</p>
			<p class="p-margins">
				כל האמור בהסכם זה בלשון זכר, אף נקבה במשמע, ובלשון יחיד, אף רבים במשמע.
			</p>

			<p class="heading">תיאור התוכנה</p>
			<p class="p-margins">
				מערכת מי-קליניק מאפשרת ניהול ממוחשב של מרפאה ו/או שירותים אחרים בענן.
			</p>
			<p class="p-margins">
				הגישה למערכת היא דרך האינטרנט, דרך מחשב, ו/או טבלט ו/או מכשיר טלפון
				נייד.
			</p>
			<p class="p-margins">
				למערכת מספר תצורות: למטפל בודד, תצורות מרובות משתמשים — כגון תצורה למטפל
				עם צוות עזר (מזכירה או מנהל חשבונות), או תצורה למכון רב-מטפלים, ריכוזי
				ו/או מבוזר. כמו כן קיימת תצורה לניהול חדרים.
			</p>
			<p class="p-margins">
				בתצורות מרובות משתמשים, יש להבחין בין "המשתמש הרשום" — אדם פרטי, תאגיד,
				עמותה, מכון או ארגון אחר (להלן ה"ארגון"), או מי שרשום מטעמם — לבין
				"המשתמש המנהל", בין אם הוא המשתמש הרשום ובין אם הוא מונה מטעמו כל עוד
				המינוי בתוקף, לבין "משתמשים נוספים", שהרשמתם והשימוש שלהם בתוכנה, כולל
				הפסקת השימוש, היא מטעם, ברשות, בתשלום ובאחריות המשתמש הרשום, ומשכך
				כפופים להחלטות המשתמש הרשום והמשתמש המנהל מטעמו, לרבות הוספה למערכת,
				אופן השימוש בה, והפסקת השימוש בה. אין לחברה כל מעורבות, אחריות או חבות
				בגין מי מהחלטות המשתמש הרשום או הראשי מטעמו.
			</p>
			<p class="p-margins">המערכת כוללת בין השאר, אך לא רק:</p>
			<p class="p-margins">
				יומן פגישות, מערכת תיעוד קליני, ניהול ותיעוד כספי (כולל הוצאת חשבוניות
				ומסמכים חשבונאיים נוספים), יומן רופא אוטומטי, אפשרות למערכת תזכורות
				מסרונים לפגישות דרך צד שלישי, מערכת תזכורות, ניהול מכתבים ומסמכים,
				התחשבנות מול גורמים מממנים, סליקה, שאלונים, אפשרות לדף מטפל עם אפשרות
				לפניות וזימון תורים ברשת, ועוד.
			</p>
			<p class="p-margins">
				המערכת מתעדת את מועדי התיעוד ואת מועדי השינויים בתיעוד על ידי המשתמש.
				המערכת מבצעת גיבוי יומי.
			</p>
			<p class="p-margins">
				בתצורות מרובות משתמשים, המערכת כוללת גם מערכת הרשאות, מערכת ניהול
				מטפלים, מערכת התחשבנות עם מטפלים, מערכת מסרונים פנימית, יכולת קריאה
				מבסיס נתונים לפי הרשאות, ועוד. תצורות רבות משתמשים יכולות להיות של מכון
				ריכוזי, מכון מבוזר באופנים שונים, של מערכת הפניות למטפלים עמיתים, ו/או
				שילוב ביניהם.
			</p>
			<p class="p-margins">
				המערכת מתעדכנת כל העת. מוסכם שהחברה רשאית לשנות בכל עת את תכונותיה, מה
				היא כוללת ואת הממשק, לפי שיקול דעתה הבלעדי, עם או בלי הודעה מוקדמת,
				לרבות שינוי במבנה, בזמינות, ו/או להפסיק את פעילות המערכת או כל חלק ממנה,
				מכל סיבה שהיא, מבלי חובה להודיע ומבלי חבות כלשהי כלפי המשתמש ו/או
				מטופליו ו/או צד שלישי אחר, ולא תהיה למשתמש כל טענה בגין שינויים אלה.
			</p>

			<p class="heading">זכות השימוש בתוכנה</p>
			<p class="p-margins">רשות השימוש מותנית בתנאים המצטברים הבאים:</p>
			<ul>
				<li class="li-margins">המשתמש בגיר וכשיר משפטית.</li>
				<li class="li-margins">
					הסכמה ואישור המשתמש לתנאי שימוש אלה ולמדיניות הפרטיות, במלואם וללא
					סייג, מעצם השימוש בתוכנה, אלא אם הוסכם אחרת במפורש ובכתב בין בעלת
					התוכנה למשתמש.
				</li>
				<li class="li-margins">
					המשתמש מצהיר שהוא אזרח ותושב ישראל ובעל תעודת זהות ישראלית תקפה, או
					עמותה רשומה בישראל, או תאגיד, עמותה ו/או ארגון אחר המאוגד ורשום כדין
					בישראל.
				</li>
				<li class="li-margins">
					ככל שההרשמה היא מטעם תאגיד, עמותה ו/או ארגון אחר, מבצע ההרשמה קיבל את
					כל האישורים הנדרשים מהעמותה או התאגיד ו/או חברי הארגון, לפי העניין,
					לצורך ביצועה.
				</li>
				<li class="li-margins">
					שימוש המשתמש במערכת הוא בהתאם לכל דין ואינו מפר כל חוק, תקנה או כל
					התחייבות שעשויה להיות למשתמש או למי מטעמו.
				</li>
				<li class="li-margins">
					המשתמש בעל אמצעי תשלום תקף שאושר ע"י חברת כרטיסי האשראי וחברת הסליקה.
				</li>
				<li class="li-margins">
					המשתמש המציא אמצעי התקשרות תקפים ופעילים (לרבות כתובת דוא"ל ומספר
					טלפון נייד). שימוש בהם הוא תנאי לשימוש במערכת.
				</li>
			</ul>
			<p class="p-margins">
				זכות השימוש הניתנת למשתמש היא אישית ואינה ניתנת להעברה. המשתמש אינו רשאי
				להמחות, להעביר או להסב את זכויותיו והתחייבויותיו לפי תנאי השימוש, כולן
				או חלקן, וכל ניסיון הסבה כאמור יהיה בטל ומבוטל. כנ"ל לגבי תאגיד, עמותה
				ו/או ארגון אחר.
			</p>
			<p class="p-margins">
				בין הצדדים לא מתקיימים ולא יתקיימו יחסי עובד-מעביד, יחסי הרשאה, יחסי
				סוכנות או יחסי שותפות, לכל צורך שהוא.
			</p>
			<p class="p-margins">
				בתצורות מרובות משתמשים, זכות השימוש ניתנת למשתמש הרשום, לרבות כפי שהיא
				באה לידי ביטוי בהחלטות המשתמש המנהל ככל שמונה על ידו. הוא רשאי לצרף או
				להפסיק שימוש של משתמשים נוספים העושים שימוש בתוכנה מטעמו, וכפופים לזכות
				השימוש של המשתמש הראשי.
			</p>
			<p class="p-margins">
				המשתמש הרשום ו/או המשתמש המנהל מטעמו נושאים באחריות לתשלום עבור השימוש
				במערכת עבור כל המשתמשים מטעמו, כמו גם לשימוש שלהם במערכת.
			</p>
			<p class="p-margins">
				חובת ואחריות המשתמש הראשי ו/או המשתמש המנהל מטעמו ליידע את כל המשתמשים
				הנוספים מטעמו על תנאי השימוש ועל חובתם לעמוד בהם, וכן על כל התאמה
				ייחודית הנדרשת על ידו או מותאמת עבור הארגון. כל חריגה מכללי השימוש על
				ידי מי מהמשתמשים מטעם ארגון תהיה באחריות הארגון, לרבות במקרי נזק ישיר או
				עקיף, כולל למטופליהם, לקוחותיהם או לצד ג' כלשהו. אין לחברה כל אחריות או
				חבות בגין החלטותיו ו/או פעולותיו, כולל כלפי המשתמשים הנוספים.
			</p>
			<p class="p-margins">
				בעת החלפת משתמש ראשי או מנהל על ידי ארגון, באחריות הארגון ו/או המשתמש
				הראשי לוודא ולגרום כי גישת המנהל המוחלף ו/או הרשאותיו, לפי העניין,
				יילקחו ממנו מיידית ויועברו למנהל החדש. כיוצא בזה גם בכל הפסקת שימוש על
				ידי כל משתמש אחר במערכת המכון.
			</p>
			<p class="p-margins">
				גם בתצורה מרובת משתמשים, חל איסור מוחלט לבצע בתוכנה שימוש משותף על ידי
				יותר ממשתמש אחד — יש לרכוש רישיון שימוש נפרד לכל משתמש, ועל כל משתמש
				להיות מזוהה באופן אישי בשמו. שימוש החורג מכללים אלה יוצר פרצת אבטחה
				ומהווה הפרה יסודית של תנאי השימוש.
			</p>
			<p class="p-margins">
				רשות השימוש כפופה לתשלום. משתמשים נוספים מטעם ארגון כפופים לתנאים ו/או
				הסכמות ו/או שינויים ו/או תשלום של המשתמש הרשום ו/או הראשי, ולא תהיה להם
				כל טענה במידה והשימוש שלהם יופסק עקב הפסקת השימוש עבור מי מהם ו/או כל
				שינוי אחר בשימוש ו/או בגישה לתוכנה על ידי המשתמש הרשום, מכל סיבה, מצדו
				או מצד בעלת התוכנה, כולל אך לא רק הפסקת תשלום.
			</p>

			<p class="heading">תשלום</p>
			<p class="p-margins">השימוש בתוכנה מותנה בתשלום.</p>
			<p class="p-margins">
				המשתמש זכאי לחודש שימוש חינם, החל מיום הרשמתו, ללא התחייבות כספית או
				אחרת, למעט אם נקבע אחרת.
			</p>
			<p class="p-margins">
				חודש לאחר ההרשמה, המשתמש יתבקש למלא את פרטי כרטיס האשראי דרך התוכנה
				כתנאי להמשך השימוש במערכת. תשלום בכרטיס אשראי מותנה באישור אמצעי התשלום
				ע"י חברת כרטיסי האשראי וחברת הסליקה.
			</p>
			<p class="p-margins">
				דמי השימוש הם 89 ₪ + מע"מ לחודש לכל משתמש בתוכנה. בתצורה מרובת משתמשים,
				באחריות המשתמש הרשום ו/או הארגון ו/או המשתמש המנהל לשלם עבור כל אחד
				מהמשתמשים מטעמו, לרבות הוא עצמו.
			</p>
			<p class="p-margins">
				התשלום הראשון ייגבה כחלק היחסי של יתרת החודש הקלנדרי בו נמסרו פרטי כרטיס
				האשראי. התשלומים הבאים ייגבו מכרטיס האשראי, כל חודש מראש, בראשון לאותו
				חודש.
			</p>
			<p class="p-margins">
				החברה זכאית לקבוע דמי שימוש שונים למנויים שונים, לקבוע תעריפים נפרדים
				לשירותים מסוימים, ולעדכן את התעריפים מעת לעת, כפי שמופיע
				<a
					class="link-terms"
					href="https://www.my-cliniq.com"
					target="_blank"
					>באתר החברה</a
				>.
			</p>
			<p class="p-margins">
				ההחלטה על תשלום היא של המשתמש בלבד ומהווה הסכמה לתנאי הסכם השימוש
				ומדיניות הפרטיות במלואם. ככל שמדובר בארגון רשום ו/או מאוגד, התשלום עבור
				כלל המשתמשים במערכת מטעמו הוא באחריות הארגון ו/או המשתמש הרשום ו/או
				המשתמש הראשי, כולם יחד וכל אחד לחוד. ככל שמדובר בארגון לא רשום ו/או לא
				מאוגד, התשלום עבור כלל המשתמשים במערכת מטעמו הוא באחריות הארגון ו/או
				המשתמש הרשום ו/או המשתמש הראשי ו/או כל אחד מהמשתמשים, כולם יחד וכל אחד
				לחוד.
			</p>
			<p class="p-margins">
				התשלום עבור השימוש במערכת אינו כולל עלויות נוספות מצד מפעילי רשתות ו/או
				מפעילי תקשורת ו/או ספקי חוץ הקשורות לגישה ו/או לשימוש ו/או לאבטחה ו/או
				לכל היבט אחר במערכת, או מצד ספקי שירותים נוספים כגון שירותי מסרונים או
				סליקה. עלויות אלה כפופות להסכמים בין המשתמש לבין המפעילים ואינן כלולות
				בעלות השימוש במערכת, למעט אם סוכם אחרת במפורש ובכתב בין המשתמש לחברה.
				החברה לא תהיה אחראית לעלויות אלה.
			</p>
			<p class="p-margins">
				במידה והמשתמש יבחר להשתמש בשירות המסרונים, החברה תישא בעלות שליחה של עד
				600 מסרונים (SMS) לחודש למשתמש. מוסכם שאין בהטבה זו, או בכל הטבה אחרת
				מול ספק חוץ כלשהו, כדי להקים חבות כלשהי של החברה ביחס למערכת המסרונים או
				לאותו ספק חוץ.
			</p>

			<p class="heading">הפסקת שימוש</p>
			<p class="p-margins">
				המשתמש רשאי להפסיק את השימוש במערכת בכל עת לפי שיקול דעתו הבלעדי. הפסקת
				השימוש היא על ידי הודעת המשתמש לחברה במייל ולאחר קבלת אישור מנציג החברה
				במייל על קבלת ההודעה.
			</p>
			<p class="p-margins">
				תקופת השימוש תסתיים בסוף החודש הקלנדרי בו התקבל אישור החברה, ובלבד
				שההודעה התקבלה ואושרה שבעה ימי עבודה לפני תום החודש.
			</p>
			<p class="p-margins">
				בתצורה רבת משתתפים, ההחלטה על שימוש, שינוי באופן השימוש ו/או הפסקת שימוש
				של המשתמשים הנוספים היא של המשתמש הרשום בלבד, כפי שהיא מתבטאת בהחלטות
				המשתמש המנהל. אין לחברה מעורבות ו/או אחריות כלפי החלטות אלה ו/או
				השלכותיהן ו/או נזקים אפשריים למשתמשים, למטופליהם ו/או לצד שלישי בגין
				החלטות המשתמש המנהל, והיא לא תישא בכל חבות בגין השלכות ו/או נזקים אלו.
			</p>
			<p class="p-margins">
				זכות השימוש תפקע אוטומטית ומיידית, ללא צורך בהודעה מראש ו/או אחרת
				מהחברה, בתום תקופת הניסיון ו/או בתום התקופה שעבורה המשתמש שילם על השימוש
				בתוכנה ו/או במקרה שבו המשתמש הפר אחת או יותר מהוראות הסכם זה.
			</p>
			<p class="p-margins">
				בכל מקרה שלא יבוצע בפועל תשלום כלשהו עבור השימוש בתוכנה, מכל סיבה שהיא,
				תועבר התראה למשתמש. ככל שנושא התשלום לא יוסדר תוך שבוע ימים, החברה
				זכאית, לפי שיקול דעתה הבלעדי, להפסיק את השימוש במערכת.
			</p>
			<p class="p-margins">
				החברה רשאית, לפי שיקול דעתה הבלעדי, למנוע ממשתמש להירשם ו/או להפסיק את
				השימוש בתוכנה באופן זמני או קבוע, בכל מקרה שבו יתעורר חשש כי עבר על
				הוראות הדין ו/או הפר את תנאי השימוש ו/או מסר פרטים שגויים ו/או ביצע מעשה
				או מחדל העלול לפגוע בחברה או מי מטעמה, בתוכנה או בצדדים שלישיים, ו/או יש
				חשש לפריצה ו/או שימוש לא ראוי במערכת. אין בחסימה, בהפסקה או בהגבלת
				השימוש כאמור לעיל כדי להטיל על החברה אחריות כלשהי ו/או כדי לגרוע מחובתו
				של המשתמש לנהוג בכל עת בהתאם לתנאים. זכות זו של החברה תקפה גם לגבי
				משתמשים נוספים במערכות מרובות משתמשים.
			</p>
			<p class="p-margins">
				לפני פקיעת זכות השימוש במערכת, מכל סיבה שהיא ובהתאם להחלטת כל גורם שהוא,
				באחריות המשתמש לגבות אליו תוך שבוע את המידע שהזין למערכת. באחריות המשתמש
				להודיע לחברה על השלמת תהליך זה.
			</p>
			<p class="p-margins">
				במקרה בו השימוש הופסק עקב הפרת תנאי ההסכם, על המשתמש להפסיק כל שימוש
				במערכת, למעט הורדת המידע השמור בה, תוך שבעה ימים.
			</p>
			<p class="p-margins">
				במקרה של חשד לפריצה ו/או כל שימוש אחר לא ראוי במערכת, זכות השימוש תוחזר
				עם בירור הנושא וטיפול בו באופן שיאפשר חזרה בטוחה לשימוש.
			</p>
			<p class="p-margins">
				עם סיום השימוש במערכת, החברה שומרת לעצמה את הזכות למחוק, לפי שיקול דעתה,
				את המידע האגור במערכת כעבור 60 יום מפקיעת זכות השימוש בה.
			</p>
			<p class="p-margins">
				בהתאם להוראות חוק הגנת הצרכן, התשמ"א-1981, והתקנות שהותקנו על פיו, צרכן
				הרוכש מוצר או שירות בעסקת מכר מרחוק רשאי לבטל את העסקה. במקרים המנויים
				בסעיף 14ג(ד) לחוק הגנת הצרכן לא ניתן לבטל את העסקה כאמור (לנוסח המלא של
				החוק ראו אתר משרד התעשייה והמסחר).
			</p>

			<p class="heading">שאלונים</p>
			<p class="p-margins">המערכת מאפשרת הקמה ושימוש בשאלונים.</p>
			<p class="p-margins">
				המשתמש מתחייב להשתמש בשאלונים, ו/או בתוכנה בכלל, לפי חוק, ובפרט תוך
				כיבוד הקניין הרוחני של כל צד ג'. עליו החובה לוודא שקיימת לו זכות שימוש.
				וככל שחובה זו תופר, המשתמש יודע ומסכים שכל האחריות על שימוש לא מורשה חלה
				עליו, והוא מתחייב לשפות ו/או לפצות ו/או לשבב את החברה במידה ותיתבע על
				רקע זה, עם דרישתה הראשונה.
			</p>
			<p class="p-margins">
				מוסכם ומובן שהפרטים המועברים דרך השאלונים הם באחריות המטופלים ו/או אחרים
				הממלאים את השאלונים.
			</p>
			<p class="p-margins">
				השימוש המושכל בשאלונים כרוך בהיכרות עם משמעותם ובשיקול דעת קליני. שימוש
				זה מותנה בהסכמה לכך שהחברה לא תהיה אחראית לכל טעות מכל סוג שהוא, מכל צד
				שהוא וכלפי כל צד ג' שהוא, הנובעת מהקמה, שימוש, תקשור, הסקת מסקנות ו/או
				כל אופן אחר הכרוכים בשימוש בשאלונים — הן מצד המשתמש והן מצד ממלא השאלון.
			</p>

			<p class="heading">סייען AI</p>
			<p class="p-margins">
				מי-קליניק מאפשרת שימוש במערכת בינה מלאכותית (AI) לצורכי תמיכה והדרכה
				באתר/באפליקציה.
			</p>
			<p class="p-margins">
				המערכת פועלת בסביבה מבודדת לחלוטין. הגישה של מערכת ה-AI מוגבלת אך ורק
				למאגר מידע סגור של שאלות ותשובות נפוצות (FAQ). ה-AI מעבד את שאלות המשתמש
				בנושאי תפעול המערכת בלבד כדי לספק הנחיות תמיכה ושימוש.
			</p>
			<p class="p-margins">
				אין לסייען ה-AI כל גישה, ישירה או עקיפה, למידע אישי, מזהה, רפואי, או כל
				מידע אחר המאוחסן במערכת מי-קליניק. הסייען אינו שומר מידע ואינו משתמש
				במידע לאימון עצמי.
			</p>
			<p
				class="p-margins"
				style="font-weight: bold"
			>
				בעת פנייה לסייען ה-AI, יש להעלות רק שאלות הנוגעות לשימוש במערכת. חל
				איסור מוחלט להעלות כל פרט הנוגע למטופלים ספציפיים (שם, פרטים מזהים,
				פרטים אישיים או רפואיים, התחשבנות, או כל מידע אחר), גם בלא זיהוי מפורש,
				שכן לעתים הסייען עלול להסיק במי ובמה מדובר
			</p>
			<p class="p-margins">
				מוסכם שהשימוש בסייען ה-AI מותנה בהקפדה מוחלטת על כללים אלה. כל חריגה
				מהם, גם בשוגג, וכל נזק כתוצאה משימוש זה, כולל לצד שלישי כלשהו ו/או שיפוי
				ו/או שיבוב, הינו באחריות המשתמש בלבד.
			</p>

			<p class="heading">דף משתמש ואפשרות לפניות וזימון תורים ברשת</p>
			<p class="p-margins">
				המערכת מאפשרת העלאה לרשת של דף משתמש הכולל פרטים ביחס למשתמש ולשירותים
				שהוא מציע (שם, תואר, השכלה, ניסיון מקצועי, שירותים הניתנים, הקהל לו
				מוצעים השירותים וכיוצא בזה).
			</p>
			<p class="p-margins">
				בנוסף, המערכת מאפשרת הצעת אפשרות לפנייה ישירה אל המשתמש ו/או בקשה לתיאום
				פגישה, בהתאם להקצאת הזמנים שקבע המשתמש מראש ובהתאם לפגישות שנקבעו בפועל.
				עם קבלת המידע, המשתמש יכול לאשר או לדחות אותה, או לפנות אל הפונה בבקשה
				למידע נוסף, הבהרות או הצעת מועד אחר.
			</p>
			<p class="p-margins">
				המשתמש הוא האחראי הבלעדי לנכונות, דיוק ושלמות המידע, השירותים והמועדים
				לפגישה שהוא מציג באתר. הכוונה למידע המוצג על ידו, לרבות מידע הנמצא
				בקישורים המוצגים באתר, וכן מידע המקושר דרך שרשור קישורים ו/או מידע הנשלח
				על ידו (ה"מידע המוצג").
			</p>
			<p class="p-margins">
				החברה שומרת לעצמה את הזכות לפנות אל המשתמש ולבקש מסמכים לאימות המידע
				המוצג באתר.
			</p>
			<p class="p-margins">בנוסף, המשתמש מצהיר ומתחייב:</p>
			<ul>
				<li class="li-margins">
					הוא האחראי הבלעדי למידע המוצג, לרבות לכך שהמידע המוצג אינו מפר זכויות
					של צד שלישי כלשהו, לרבות זכויות קניין רוחני כגון סימני מסחר, תוכנות
					מחשב מוגנות, קבצים, תמלילים, תווים, קבצי שמע, עבודות אמנות וכיו"ב.
					המשתמש יימנע מכל אמצעי לעקיפה ו/או הסרה ו/או ביטול הגנות דיגיטליות על
					תוכנות ו/או קבצים ו/או כל מידע אחר, לרבות קבצי שמע, בין של האתר ובין
					אחרות.
				</li>
				<li class="li-margins">
					המידע המוצג אינו מפר כל חוק וכל דין, ואינו מעודד/תומך/מסייע/מספק
					הוראות/מנחה להפרת חוק. המשתמש מתחייב להימנע מכל מידע ו/או הצעת שירות
					המנוגדים לחוק ו/או פוגעניים, גם לא דרך קישורים באתר ו/או שרשור
					קישורים. החברה לא תישא בכל אחריות נזיקית או פלילית כתוצאה מפרסום כאמור
					או מהיענות לו, ושומרת את זכותה לפנות במקרה הצורך לרשויות אכיפת החוק,
					תוך חשיפת פרטי המשתמש.
				</li>
				<li class="li-margins">
					להימנע מפרסום או העברת תכנים הנוגעים לקטינים המזהים אותם, כגון שם, מען
					ודרכי התקשרות עמם.
				</li>
				<li class="li-margins">
					להימנע מפגיעה בצנעת הפרט, ממסירת פרטי אדם (לרבות שמו) בלא הסכמתו,
					מהוצאת דיבה ומהטרדה.
				</li>
				<li class="li-margins">
					להימנע מהעתקה ו/או שכפול ו/או שינוי ו/או הפצה ו/או פרסום תכנים של
					האתר.
				</li>
				<li class="li-margins">
					להימנע מכל פעולה ו/או תוכנת מחשב ו/או קוד מחשב ו/או יישום העלולים
					ליצור, להתערב, להפריע או להזיק לאתר או למשתמשיו, ו/או ליצור עומס על
					מערכות ושרתי האתר.
				</li>
			</ul>
			<p class="p-margins">
				מוסכם ומובן שהמידע המתקבל על ידי המשתמש ממערכת הזימון הוא באחריות מעביר
				המידע — מטופל או אחר — ותלוי בגורמים שונים כגון דפדפנים ושירותי תשתית
				רשת שהחברה אינה אחראית להם. החברה לא תהיה אחראית לכל טעות מכל סוג שהוא,
				מכל צד שהוא וכלפי כל צד ג' שהוא, הנובעת מהקמה, שימוש, תקשור, העברה,
				יירוט מידע, הסקת מסקנות ו/או כל אופן אחר הכרוכים בשימוש במערכת זימון
				התורים — הן מצד המשתמש והן מצד ממלא השאלון, כלפי כל צד ג' שהוא.
			</p>
			<p class="p-margins">
				החברה רשאית, לפי שיקול דעתה הבלעדי, להסיר ו/או לשנות ו/או לערוך תכנים
				שאינם עומדים בכללי האתר או אסורים לפי חוקי מדינת ישראל, ו/או למנוע שימוש
				בהצגת דף משתמש ו/או אפשרויות פנייה ו/או זימון תור אליו.
			</p>
			<p class="p-margins">
				המשתמש מתחייב לשפות, לפצות ו/או לשבב את החברה בגין כל נזק, הפסד, חבות,
				הוצאות והפסד הכנסה שייגרמו לה כתוצאה מהפרת מי מתנאים אלה ו/או עקב תביעה
				ו/או דרישה שתופנה אליה מצד שלישי כלשהו, שעילתה קשורה ישירות או בעקיפין
				למידע המוצג על ידי המשתמש, לרבות פגיעה בשם הטוב, בפרטיות, בקניין ו/או
				הפרת כל דין, ו/או כל הפרה אחרת ו/או נזק שנגרם בעקבותיה במישרין או
				בעקיפין, כולל לצד ג' כלשהו.
			</p>
			<p class="p-margins">
				במידה ותופנה לחברה תביעה או דרישה כלשהי מצד ממלא הפרטים ו/או צד שלישי
				כלשהו, המשתמש מתחייב לסייע לחברה כמיטב יכולתו, לרבות העברת מידע על ממלא
				הפרטים, ככל שיידרש לחברה לשם הגנה ו/או מענה לתביעה ו/או לדרישה.
			</p>

			<p class="heading">הפצת תוכן ע"י המשתמש</p>
			<p class="p-margins">
				המשתמש מתחייב כי שיגור דברי פרסומת ו/או כל פנייה אחרת לצד שלישי ו/או
				ללקוחותיו באמצעות התוכנה, כולל דרך ספק חיצוני, ייעשה בכפוף להוראות כל
				דין ולהוראות חוק התקשורת (בזק ושידורים) (תיקון מס' 40), התשס"ח–2008
				("חוק התקשורת"), לרבות קבלת אישור בכתב של הנמען.
			</p>
			<p class="p-margins">
				מובהר כי החברה אינה אחראית לתוכן הודעות כאמור שנשלחו לצד ג' כלשהו,
				ולחברה, מפעילי התוכנה וכל גורם הקשור עמם, לא תהא כל חבות או אחריות מכל
				סוג ואופן בקשר לעניין זה. יובהר כי במידה ותיגרם לחברה הוצאה כספית כלשהי
				כתוצאה מהפרת התחייבות זו על ידי המשתמש, בין אם נעשתה במכוון ובין אם לאו,
				תהא החברה זכאית לקבלת שיפוי ו/או שיבוב מהמשתמש בגובה ההוצאות הכספיות
				שנגרמו לה.
			</p>
			<p class="p-margins">
				הפרה של אחת או יותר מהתחייבויות המשתמש בסעיף זה תהווה הפרה יסודית של
				זכויות החברה בתוכנה ושל הסכם זה, ותביא לפקיעה מיידית של ההרשאה לשימוש
				בתוכנה. במקרה של הפרה כאמור, המשתמש מסכים בזאת באופן בלתי חוזר כי יינתן
				לטובת החברה כל סעד חוקי לשם מניעת ההפרה, לרבות צו מניעה זמני וקבוע,
				והגנה על זכויותיה.
			</p>
			<p class="p-margins">
				בתצורה רבת משתמשים, המשתמש הרשום ו/או המשתמש הראשי מטעמו יישאו באחריות
				ליידע ולפעולות של משתמשים נוספים מטעמם, ויישאו בחבויות הנגזרות מהפרת
				החובות האמורות על ידי מי מהמשתמשים מטעמם.
			</p>

			<p class="heading">תצורות רבות משתמשים (מכון)</p>
			<p class="p-margins">
				המערכת מאפשרת הקמת תצורות רבות משתמשים במספר מערכים:
			</p>
			<p class="p-margins">
				<b>א. מערכת מכון ריכוזי</b> — כל המטפלים והמטופלים הם מטעם המכון. כל
				התשלומים נעשים למכון והמטפלים משולמים על ידו. מוסכם שלמנהלי המכון תהיה
				הסמכות להחליט אילו נתונים יהיו נגישים למי, בכפוף למגבלות החוק.
			</p>
			<p class="p-margins">
				<b>ב. מערכת מכון מבוזר</b> — מאפשרת גמישות ביחסים בין המטפל למכון.
				היחסים בין המכון והמטפל כפופים להסכמים ביניהם וכוללים בין השאר: האם
				המטופלים מטעם המכון או המטפל, לפקודת מי נעשים התשלומים, ההסדרים הכספיים
				והמעקב אחריהם, מהו המידע הנגיש לכל אחד מהצדדים וכיוצא בזה.
			</p>
			<p class="p-margins">
				<b>ג. מערכת הפניות לעמיתים</b> — מאפשרת ניהול הפניות למטפלים עמיתים
				("עמיתים"). הגורם המפנה (המכון) יוכל להזמין עמיתים להירשם לשירות דרך
				מי-קליניק לקבלת הפניות דרכו. היחסים בין המכון והעמית כפופים להסכמים
				ביניהם, וכוללים בין השאר: האם המטופלים מטעם המכון או העמית, לפקודת מי
				נעשים התשלומים, ההסדרים הכספיים והמעקב אחריהם, מהו המידע הנגיש לכל אחד
				מהצדדים וכיוצא בזה.
			</p>
			<p class="p-margins">
				<b>ד. מערכת משולבת</b> — ניהול מכון (ריכוזי או מבוזר) יחד עם מערכת
				הפניות. ניתן לשלב את מערכת ההפניות עם מערכת מכון ריכוזי או מבוזר, בכפוף
				להסכמים בין המכון למטפלים ו/או עמיתים.
			</p>

			<p class="heading">מגבלות על רשות שימוש בתוכנה</p>
			<p class="p-margins">
				השימוש בתוכנה הוא בתום לב, לשם ניהול קליניקה בלבד, בהתאם לכללי הסכם זה
				בלבד.
			</p>
			<p class="p-margins">
				המשתמש לא ינסה לסכל, למנוע, לשבש או להפריע בצורה כלשהי לתכונות הקשורות
				באבטחת המערכת או לתכונות המונעות או מגבילות שימוש או העתקה של תוכן
				משתמש. המשתמש לא ישתמש בכל רובוט, מנוע אחזור וחיפוש מידע, או בכל כלי
				אוטומטי או ידני אחר המתוכנן לאנדקס, לאתר ולאחזר מידע במערכת הניהול, או
				כלי כאמור המתוכנן לחשוף את מבנה מאגר הנתונים והקוד במערכת.
			</p>
			<p class="p-margins">
				המשתמש לא יבצע פנייה אל שרתי החברה או אל מאגרי המידע/בסיסי הנתונים שלא
				באמצעות ממשק המשתמש. המשתמש לא יבצע שינויים בקוד הנמצא במכשיר
				הלקוח/דפדפן ו/או לא ייגש למידע שאינו מורשה לגשת אליו, וכו'.
			</p>
			<p class="p-margins">
				המשתמש לא יעשה שימוש בחשבון או בסיסמה של משתמש אחר, ולא ישתמש במערכת בכל
				אופן שאינו מאושר לפי תנאי שימוש אלה.
			</p>
			<p class="p-margins">
				המשתמש לא יעביר פרטי חשבון או סיסמה שלו לאחר, ו/או לא יאפשר במעשה או
				במחדל שימוש כזה על ידי אחר כלשהו, אלא כדי שיפעל בשמו ועבורו. מוסכם
				ומובהר שהמשתמש יהיה אחראי לכל נזק מכל סוג שייגרם לאתר ו/או לחברה ו/או
				לכל צד שלישי ו/או לשיבוב, כתוצאה משימוש מעין זה, בין על ידו ובין על ידי
				אחר.
			</p>
			<p class="p-margins">
				המשתמש מצהיר, יודע ומסכים שניסיונות מסוג זה עלולים להביא לחסימה אוטומטית
				של חשבון המשתמש ולסגירה לצמיתות של החשבון.
			</p>

			<p class="heading">שירותי צד ג' ("ספקי חוץ")</p>
			<p class="p-margins">
				החברה עשויה לאפשר למשתמש, מעת לעת, להתחבר באמצעות התוכנה לשירותים
				המצויים בבעלות, ניהול והפעלה של צדדים שלישיים ("ספקי חוץ"), כגון שירותי
				סליקה, משלוח מסרונים ועוד.
			</p>
			<p class="p-margins">
				השימוש בשירותים אלה כפוף לבחירתו ושיקול דעתו של המשתמש. שימוש בשירותי
				ספק חוץ מבטא את הסכמת המשתמש לתנאי השימוש, אבטחת המידע והפרטיות העדכניים
				של אותו ספק חוץ.
			</p>
			<p class="p-margins">
				עם בחירת המשתמש להתחבר לשירות של ספק חוץ באמצעות התוכנה, ייתכן ויועברו
				לצד השלישי, באמצעות המערכת, פרטי ההרשמה ופרטים אחרים של המשתמש.
			</p>
			<p class="p-margins">
				מובהר כי החברה אינה צד לשימוש של המשתמש בשירותי צדדים שלישיים ו/או
				להתקשרות עמם, ולא תישא בכל אחריות או חבות לשירותים המסופקים על ידם ו/או
				לכל הפסד, נזק, תקלה, פגם ו/או הוצאה מכל מין שהוא שייגרמו למשתמש ו/או
				למטופליו ו/או לכל צד שלישי, כתוצאה משימוש ו/או אי-שימוש ו/או כשל כלשהו
				בשירותים אלה ו/או בגישה אליהם ומהם.
			</p>
			<p class="p-margins">
				ספק החוץ הוא האחראי הבלעדי על תקינות השירות שהוא מספק ועל עמידתו בחוקים
				הרלוונטיים. המשתמש מצהיר כי ידוע לו שהחברה אינה מנהלת, מפקחת על, או
				מספקת את השירותים האלה, אלא מעמידה אותם לרשות המשתמש לפי שיקול דעתו
				והחלטתו בלבד. אין החברה מציגה כל מצג, הבטחה או התחייבות להתאמת שירותי
				צדדים שלישיים לצרכי המשתמש ו/או לכך שהשימוש בהם יהיה רציף וללא הפרעות או
				תקלות.
			</p>

			<p class="heading">מדיניות ההגנה על הפרטיות</p>
			<p class="p-margins">
				המידע שנשמר על ידי המשתמש במערכת מוצפן ונעשה בו שימוש על ידי המשתמש
				בלבד. החברה לא תיגש אל המידע ללא בקשה ו/או רשות מפורשת של המשתמש.
			</p>
			<p class="p-margins">
				החברה אינה עושה כל שימוש במידע המוזן על ידי המשתמש לתוכנה. מידע כאמור לא
				ייחשף לעובדים ו/או נותני שירותים של החברה, כגון מתכנתים או טכנאים, אלא
				באופן מוגבל, ורק כאשר החשיפה חיונית לתפעול, תחזוקה ומתן תמיכה טכנית
				למשתמש ברשותו.
			</p>
			<p class="p-margins">
				פרטי האשראי של המשתמש לתשלום עבור השימוש במערכת אינם נאספים על ידי
				החברה, אלא טוקן בלבד המאפשר גישה לשירותי הסליקה.
			</p>
			<p class="p-margins">
				החברה אוספת מידע הכולל פרטי הרשמה שמוזנים על ידי המשתמש, ומידע סטטיסטי
				על השימוש בתוכנה. השימוש בפרטי ההרשמה נועד אך ורק לצורך התקשרות בין
				החברה למשתמש. מידע סטטיסטי על השימוש בתוכנה נאסף לשם שיפור פעילות התוכנה
				והשירותים המוצעים בה, ובכפוף לכל הוראת דין.
			</p>
			<p class="p-margins">
				החברה לא תעביר לצדדים שלישיים את פרטי ההרשמה, נתונים סטטיסטיים או כל
				מידע אחר המוזן על ידי המשתמש לתוכנה, אלא במקרים הבאים:
			</p>
			<ul>
				<li class="li-margins">
					העברת פרטי הרשמה הנדרשים לשם הרשמה, השלמת רכישה ושימוש בשירותים מצדדים
					שלישיים הנרכשים ו/או נעשה בהם שימוש דרך התוכנה, כגון שליחת מסרונים,
					שירותי סליקה ועוד.
				</li>
				<li class="li-margins">
					צו או הוראה שיפוטית, מינהלית או אחרת מרשות מוסמכת בהתאם לחוק או
					לתקנות, המורה לחברה למסור פרטים או מידע.
				</li>
				<li class="li-margins">
					במידה והחברה תמכור, תעביר פעילות, תתמזג או תמזג פעילות עם גוף אחר —
					הגישה למידע תינתן לו, ובלבד שהתאגיד האחר יקבל על עצמו את כל הוראות
					מדיניות פרטיות זו כלפי המשתמשים.
				</li>
			</ul>
			<p class="p-margins">
				המערכת משתמשת ב"עוגיות" (Cookies) לצורך תפעולה השוטף והתקין, ובכלל זה
				לאימות גישה למערכת ולצורכי אבטחת מידע. בעצם הרשמה לתוכנה, המשתמש מאשר את
				השימוש בעוגיות כאמור. חסימה או מחיקה של עוגיות לא תאפשר שימוש במערכת.
			</p>
			<p class="p-margins">
				הרשמה למערכת מהווה הסכמה על פי דין מצד המשתמש לקבלת דיוור ישיר מהחברה,
				ובכלל זה מידע הנוגע לשימוש במערכת, תפעולה, תחזוקה ושירותי תמיכה,
				עדכונים, שירותים משלימים ומידע שיווקי.
			</p>
			<p class="p-margins">
				השימוש באימייל של המשתמש הוא לצרכי השימוש במערכת. עם זאת, המשתמש זכאי
				להימחק מרשימת הדיוור היזום של החברה, בפנייה במייל, בהקלקה על אפשרות
				ההסרה המופיעה בכל אימייל שנשלח מהמערכת, או בדואר לכתובת ק"מ 74, רמת
				החייל, תל אביב. משתמש שיימחק מרשימת הדיוור יישא באחריות מלאה ובלעדית לכל
				נזק, אובדן או הפסד שייגרמו לו בשל אי-קבלת מידע מהחברה.
			</p>
			<p class="p-margins">
				על פי חוק הגנת הפרטיות, התשמ"א-1981, המשתמש בתוכנה זכאי לעיין במידע שלו
				המוחזק במאגר המידע. משתמש שעיין במידע שעליו ומצא כי אינו נכון, שלם, ברור
				או מעודכן, רשאי לפנות לבעל מאגר המידע בבקשה לתקנו או למוחקו. פנייה כזאת
				יש להפנות במייל לכתובת
				<a href="mailto:support@my-cliniq.com">support{{ "@" }}my-cliniq.com</a
				>, או בדואר רשום לכתובת ק"מ 74, רמת החייל, תל אביב.
			</p>
			<p class="p-margins">
				על כל משתמש מוטלת אחריות לוודא שהוא מקיים את כל החובות החלות עליו בהתאם
				לחוק זכויות החולה, חוק הגנת הפרטיות (כולל תיקון 13 לחוק זה) וכל הוראת
				דין רלוונטית אליו, ככל שישנה, ולפנות לשם כך לכל ייעוץ נדרש. ככל שמדובר
				בתצורה רבת משתמשים, באחריות הארגון ו/או מנהליו ו/או המשתמש הראשי לוודא
				שגם כל המשתמשים מטעמו יקיימו חובות אלו.
			</p>
			<p class="p-margins">
				פירוט מלא של מדיניות הפרטיות של החברה ביחס למשתמשים ניתן למצוא
				<a
					class="link-terms"
					href="https://www.my-cliniq.com/%d7%a4%d7%a8%d7%98%d7%99%d7%95%d7%aa/"
					target="_blank"
					>בקישור באתר החברה</a
				>.
			</p>

			<p class="heading">ניהול רישום רפואי, חשבונאי ואחר</p>
			<p class="p-margins">
				המערכת רשומה בהתאם לנספח ה' שבסעיף 36 להוראת מס הכנסה (ניהול פנקסי
				חשבונות), התשל"ג-1973 ("החוק"), כתוכנה לניהול מערכת חשבונות ממוחשבת
				<a
					class="link-terms"
					href="https://www.my-cliniq.com/wp-content/uploads/Certificate.pdf"
					target="_blank"
					>(מס' רישום 239301)</a
				>.
			</p>
			<p class="p-margins">
				החברה לא תישא באחריות אם כתוצאה משימוש במערכת הדיווח לרשויות המס לא יהיה
				מדויק, ו/או במקרה של טענת רשויות המס בדבר ניהול לא תקין וכיו"ב.
			</p>
			<p class="p-margins">
				החברה לא תישא באחריות במידה והשימוש במערכת לא ענה על הדרישות הרגולטוריות
				של משרד הבריאות ו/או כל משרד ממשלתי אחר ו/או כל גוף אחר.
			</p>
			<p class="p-margins">
				באחריות המשתמש לקבל ייעוץ מקצועי מתאים במידת הצורך.
			</p>

			<p class="heading">קניין רוחני</p>
			<p class="p-margins">
				המערכת וכל הזכויות בה הן בבעלות החברה ומוגנות על ידי חוקים ואמנות
				בינלאומיות. המבנה, הארגון, העיצוב, תהליכי העבודה והקוד של המערכת ו/או
				התוכנה הממשת אותה הם סודות מסחריים ומידע סודי מוגן של החברה.
			</p>
			<p class="p-margins">
				החברה הינה ותישאר הבעלים הבלעדית של מלוא הזכויות במערכת ובתוכנה, לרבות
				בשמות "מי-קליניק" ו-"My-Cliniq" ובכל שם, שם מסחרי, לוגו, סמל או סימן
				מסחרי שבהם ייעשה שימוש במערכת ו/או בתוכנה, בפטנטים ובמדגמים של המערכת
				ו/או התוכנה, בין רשומים ובין שאינם רשומים, בסודות מסחריים הכרוכים בהפעלת
				המערכת, בממשק, בעיצוב המערכת ו/או התוכנה, ובמידע הטכנולוגי הכרוך בהפעלתה
				— לרבות תוכנות, יישומים, קבצים גרפיים ואחרים, קודי מחשבים, טקסטים ו/או
				כל חומר אחר ("המידע").
			</p>
			<p class="p-margins">
				המשתמש מתחייב שלא להפיץ, למכור מחדש, לתת רישיון משנה, להשכיר, להחכיר או
				להשאיל את המערכת (או כל חלק ממנה) ו/או התוכנה ו/או את רשות שימוש הקצה
				בה, ללא קבלת הסכמה מראש ובכתב מהחברה.
			</p>
			<p class="p-margins">
				המשתמש מתחייב שלא לבצע ו/או לסייע לצד שלישי לבצע שינוי, תרגום, שכפול,
				העתקה או העברה של המערכת ו/או התוכנה (או כל חלק ממנה) ו/או רשות השימוש
				בה, ולא להעתיק את המערכת ו/או התוכנה. כן מתחייב שלא לבצע ו/או לסייע לצד
				שלישי לבצע הנדסה חוזרת (Reverse Engineering), הידור חוזר (Decompilation)
				או פירוק (Disassembly), ו/או בכל אופן אחר לנסות לגלות את קוד המקור של
				המערכת ו/או התוכנה, לשנותה או ליצור עבודות נגזרות המבוססות עליה.
			</p>
			<p class="p-margins">
				המשתמש מתחייב שלא לרשום או לתבוע זכויות כלשהן על התוכנה ו/או קוד המקור
				שלה, כולם או מקצתם, ו/או על עבודות הנגזרות מהם.
			</p>
			<p class="p-margins">
				המשתמש מתחייב להשתמש בתוכנה בתום לב, אך ורק בהתאם לכל החוקים החלים,
				לרבות ומבלי לגרוע, החוקים הקשורים לזכויות יוצרים וזכויות קניין רוחני
				אחרות. חל איסור מוחלט להשתמש בתוכנה באופן החורג מתנאי הסכם זה או המהווה
				הפרה של כל הוראת דין.
			</p>

			<p class="heading">אבטחת מידע</p>
			<p class="p-margins">
				החברה מקפידה על מערכות ונהלים לאבטחת מידע, תוך עמידה בדרישות הרשות להגנת
				הפרטיות. בין אמצעי האבטחה נכללים: הגנת תקשורת הנתונים בפרוטוקול מסוג
				SSL, עדכון שרתים קבוע כנגד פרצות אבטחה ידועות, חוות שרתים הכוללת
				Firewall, אבטחה פיזית וגיבויי חשמל וכיוצא באלה אמצעי אבטחה.
			</p>
			<p class="p-margins">
				החברה ונהליה עומדים בתקני החברה ונהליה עומדים בתקני
				<a
					class="link-terms"
					href="https://www.my-cliniq.com/wp-content/uploads/ISO27799.pdf"
					target="_blank"
					>ISO-27799</a
				>
				ו-<a
					class="link-terms"
					href="https://www.my-cliniq.com/wp-content/uploads/ISO27001.pdf"
					target="_blank"
					>ISO-27001</a
				>, תחת פיקוח חברת ARS Assessment Private Limited, ועומדים בדרישות החוק
				תוך צמצום הסיכון לחדירה בלתי-מורשית. עם זאת, עמידה בתקנים אינה מעניקה
				ביטחון מוחלט, ואין באפשרותם למנוע כל ניסיון גישה בלתי-מורשית.
			</p>
			<p class="p-margins">
				המשתמש מצהיר כי הוא מודע לסיכונים אלו, כי ינהג בזהירות וישמור על כללי
				האבטחה הנדרשים, וכי כל שימוש בתוכנה הוא על אחריותו, ושהוא ייוועץ בייעוץ
				חיצוני ככל שיידרש. החברה לא תישא בכל אחריות או חבות ביחס לנזקים למשתמש
				ו/או למטופליו ו/או לכל צד שלישי, שייגרמו בגין גישה לא מורשית או כל פגיעה
				אחרת, בזדון או שלא בזדון, מכל גורם שהוא, לתוכנה ולמידע.
			</p>

			<p class="heading">הגבלת אחריות</p>
			<p class="p-margins">
				המשתמש מתחייב ומצהיר שידוע לו שהשימוש במערכת ניתן "As Is" על כל מגבלותיה
				ופגמיה ככל שישנם, ובהתאם לזמינות ("As Available"), על אחריותו האישית
				והבלעדית של המשתמש, ללא אחריות מכל סוג שהוא מצד החברה.
			</p>
			<p class="p-margins">
				המשתמש מצהיר שהוא בדק ומבין את הסיכונים הכרוכים בניהול מידע רפואי ברשת,
				ואת העובדה שאין אפשרות להגנה מוחלטת על המידע ברשת.
			</p>
			<p class="p-margins">
				באחריות המשתמש לוודא שהתוכנה, על כל אחד מחלקיה, כולל אבטחת מידע ופרטיות,
				עומדת בנדרש ממנו ומתאימה לצרכיו, כולל היוועצות ככל הנדרש ברואה חשבון או
				יועץ מתאים אחר לפי העניין.
			</p>
			<p class="p-margins">
				מוסכם שכל הסתמכות על המערכת ועל התוכן המוצג דרכה היא באחריותו הבלעדית של
				המשתמש. החברה לא תישא בכל אחריות, מפורשת או משתמעת, ביחס לדיוק, אמינות,
				עמידה בזמנים, עדכניות, איכות, שלמות, שימושיות, אבטחה או ביצועי המערכת,
				התוכן ו/או השירותים ו/או העברת מידע משירות הפניות וזימון התורים, ושל כל
				מידע הזמין באמצעותם. ייתכנו טעויות במערכת ו/או במידע, והחברה לא תישא
				באחריות להן, או לשגיאות הנובעות מתוכן משתמש שגוי, שימוש בשירות ספק חוץ
				ו/או דיווח לא תקין לצד שלישי באמצעות המערכת.
			</p>
			<p class="p-margins">
				המערכת מותאמת לשימוש בהתקנים ניידים, כגון מחשבי לוח וטלפונים חכמים.
				החברה אינה יכולה להתחייב על שימוש תקין ו/או לשאת באחריות לכל סוג של נזק
				למשתמש ו/או למי ממטופליו ו/או לכל צד שלישי, שייגרם כתוצאה משימוש במערכת
				באמצעות התקנים ניידים.
			</p>
			<p class="p-margins">
				החברה מבהירה שאין לה כל התחייבות, מפורשת, משתמעת או על פי חוק, שהמערכת
				תסופק כסדרה בלא הפסקות, לאיכותה, שתתקיים בביטחה ללא טעויות, או שתהיה
				חסינה מכל גישה בלתי-מורשית למחשבי ו/או מכשירי ו/או מערכות, או מפני
				נזקים, קלקולים, תקלות או כשלים — בין היתר בחומרה, בתוכנה, בקווי ובמערכות
				תקשורת אצל החברה, אצל מי מספקיה או אצל המשתמש או מי מטעמו — ולא תהיה
				למשתמש כל טענה כלפי החברה בקשר לכך. המשתמש מודע לכך כי ייתכן ובעתיד לא
				יהיה השירות זמין, גם בשל צרכי תחזוקה, שדרוג או כל סיבה אחרת.
			</p>
			<p class="p-margins">
				החברה, מנהליה, נושאי המשרה בה, עובדיה, שליחיה או בעלי מניותיה, בשום אופן
				לא יהיו אחראים כלפי המשתמש או כלפי כל צד שלישי לכל אובדן, נזק או פיצוי
				שהוא, לרבות ללא הגבלה נזק או פיצוי כללי, אגבי, תוצאתי, נלווה, משני,
				עקיף, ישיר, עונשי או מיוחד (כולל אך לא רק נזק בגין אובדן בסיס נתונים,
				אובדן תוכנות, עלויות אספקת שירות חלופי, פגיעה בפרטיות או הפרעות בשירות),
				הנובע מכל הנוגע לתנאי שימוש אלה, מהשימוש או מאי-היכולת להשתמש במערכת
				ו/או בשירותים ו/או בתוכן ו/או בכל הקשור אליהם — זאת גם אם החברה קיבלה
				הודעה על האפשרות לאותם הפסדים. החבות הכוללת של החברה במסגרת כל תנאי
				מתנאי השימוש לא תעלה על הסכום ששולם לחברה עבור השימוש במערכת על ידי
				המשתמש בתקופה של שנים עשר חודשים לפני התביעה הרלוונטית. אם המשתמש לא
				שילם לחברה עבור השימוש במערכת, לחברה לא תהיה כל חבות כלפיו ו/או כלפי מי
				מטעמו ו/או כלפי צד שלישי.
			</p>
			<p class="p-margins">
				בהרשמה לתוכנה, המשתמש מתחייב לנקוט בכל האמצעים הנדרשים לשם שמירה על
				סודיות ופרטיות המידע הנשמר בתוכנה. אמצעים אלה כוללים, ולא רק, שמירה על
				סודיות פרטי הגישה לתוכנה (שם משתמש, סיסמה, גישה לנייד וכו'), ושמירה על
				כך שאף גורם מורשה ו/או שאינו מורשה לצפות ו/או להשתמש בתוכנה ו/או לגשת
				למידע הנשמר בה, כולו או חלקו, לא יקבל גישה לצפייה ו/או שימוש אחר מכל סוג
				בתוכנה או במידע הנשמר בה, או מגובה ממנה בכל צורה או יעד, כולל למסך בעת
				שמוצג עליו מידע מהתוכנה.
			</p>
			<p class="p-margins">
				מוסכם שהחברה לא תחוב ולא תהיה אחראית כלפי המשתמש ו/או כל צד שלישי ו/או
				לשיבוב, בכל מקרה של שימוש ו/או צפייה ו/או פגיעה ו/או חסימת שימוש ו/או
				הרס נתונים על ידי גורמים שאינם מורשים כאמור במסמך זה ו/או לפי חוק.
			</p>
			<p class="p-margins">
				המשתמש מתחייב לרכוש ולהחזיק על חשבונו חומרה, תוכנות, תשתית, ביטוח תואם
				לשימוש בתוכנה ברשת, ושירותי אינטרנט הדרושים ומתאימים לשם שימוש בתוכנה.
				החברה, לרבות כל מי מטעמה או במקומה, לא תישא בכל אחריות לציוד האישי של
				המשתמש, רשת האינטרנט ו/או רשתות התקשורת, לפעילותם או לתקלות בהן.
			</p>
			<p class="p-margins">
				על המשתמש חלה האחריות לוודא את תקינותם ואבטחתם של הדפדפנים המותקנים
				במחשב הקצה שבאמצעותו ישתמש בתוכנה, כמו גם מאפיינים, תאימות והגדרות אבטחת
				המידע של הדפדפן שבשימושו, ולחברה לא תהיה כל אחריות על נזק מכל סוג שעלול
				להיגרם למשתמש בתוכנה באמצעות דפדפנים אלה (כולל כל עדכון ו/או שדרוג ו/או
				שינוי גרסה ומאפיינים שעלולים לחול בעתיד על דפדפנים אלה) ו/או כל תוכנה
				בעלת גישה לרשת האינטרנט שדרכה ניגש המשתמש לתוכנה.
			</p>
			<p class="p-margins">
				החברה, לרבות כל מי מטעמה או במקומה, לא תישא בכל אחריות לכל נזק — לרבות
				נזק ישיר, לגוף, תוצאתי, מיוחד, עקיף ו/או נזק אקראי — שייגרם עקב השימוש
				בתוכנה, במישרין או בעקיפין, ובכלל זה נזק למשתמש ו/או למטופליו ו/או
				ללקוחותיו ו/או לשיבוב, כולל פגיעה בנפש, בגוף, נזק כלכלי כלשהו או אחר
				הנובע או קשור לשימוש בתוכנה, בכל עילת תביעה שהיא (חוזית, נזיקית או
				אחרת), גם אם החברה הוזהרה בדבר האפשרות לנזק מסוג זה. בכל נסיבות שהן,
				האחריות הכוללת של החברה כלפי המשתמש לכל נזקיו לא תעלה על המחיר ששולם על
				ידי המשתמש לחברה בפועל במשך חצי השנה שקדמה לעילת הנזק, בקשר לתוכנה.
			</p>
			<p class="p-margins">
				השימוש בתוכנה והמידע הכלול בה אינם בגדר מתן ייעוץ או חוות דעת מקצועית,
				ואינם מהווים תחליף לייעוץ מקצועי.
			</p>
			<p class="p-margins">
				החברה אינה מתחייבת לספק תיעוד של התוכנה, או כל חלק ממנה, בהווה או ביחס
				לכל פיתוח או שינוי בעתיד.
			</p>

			<p class="heading">שינוי תנאי השימוש</p>
			<p class="p-margins">
				החברה שומרת לעצמה את הזכות לעדכן את תנאי השימוש והפרטיות מעת לעת, לפי
				שיקול דעתה הבלעדי. בכל מקרה בו יבוצעו שינויים מהותיים בתנאי השימוש ו/או
				במדיניות הפרטיות, תישלח למשתמש הודעה במייל ו/או דרך התוכנה. העדכון יהיה
				בתוקף מיום פרסומו, וניתן יהיה לראות את תנאי השימוש והפרטיות המעודכנים
				במערכת ובאתר. המשך השימוש במערכת לאחר עדכון תנאי השימוש ו/או הפרטיות
				ייחשב כהסכמה לתנאים המעודכנים.
			</p>
			<p class="p-margins">
				תנאים אלה יחולו גם על עדכון של התוכנה, אלא אם יצורף לעדכון הסכם נפרד
				(ובמקרה כזה יחולו תנאיו של ההסכם הנפרד).
			</p>
			<p class="p-margins">
				בכל מקרה של סתירה ו/או אי-התאמה בין האמור בתנאים אלה לבין האמור בחלק אחר
				של התוכנה ו/או בכל פרסום אחר, הוראות תנאים אלה יגברו ויחייבו את הצדדים.
			</p>

			<p class="heading">שיפוי ושיבוב</p>
			<p class="p-margins">
				המשתמש הרשום ו/או המשתמש המנהל מטעמו מסכימים כי הם אחראים לכל תוצאה
				ישירה או עקיפה הנובעת משימוש או ניסיון שימוש במערכת על ידי המשתמש או מי
				מטעמו — כולל עובדים, מנהלים, משתמשים מטעמו ומטופליו, ככל שיש להם גישה
				למערכת — ומתחייבים לשפות ו/או לשבב את מי-קליניק, עובדיה, מנהליה או מי
				מטעמה, ולהגן עליהם, בגין כל תביעה, טענה, דרישה, הפסד, אובדן-רווח, תשלום,
				הוצאה או נזק, לרבות שכר טרחה והוצאות משפט, הוצאות מימון, עמלות, אגרות
				וכו' (כולל של צד ג' כלשהו, מטופלים, משתמשים אחרים, ספקי חוץ, חברות ביטוח
				וכיו"ב), הנובעים באופן ישיר או עקיף מ:
			</p>
			<ul>
				<li class="li-margins">
					הפרת תנאי שימוש אלה על ידי המשתמש ו/או על ידי משתמש כלשהו במחשב או
					במכשיר אחר של המשתמש או בחשבון שלו.
				</li>
				<li class="li-margins">
					הפרה של כל חוק או תקנה, לרבות ומבלי להגביל, הפרה של כל חוקי הפרטיות
					והתקנות שאליהם הם כפופים.
				</li>
				<li class="li-margins">
					הפרת זכות כלשהי של מי-קליניק ו/או צד שלישי כלשהו, כולל זכויות קניין
					רוחני של מי מהם.
				</li>
				<li class="li-margins">
					כל עניין אחר שעליו הם אחראים על פי חוק או על פי דין.
				</li>
			</ul>

			<p class="heading">הסכם כולל</p>
			<p class="p-margins">
				הסכם זה מבטא, ממצה ומכיל את כל ההסכמות בין הצדדים, ומבטל כל מצג, הסכם,
				הצעה והתחייבות קודמים (בכתב או בעל-פה) שלא נכללו בו במפורש. כל שינוי של
				ההסכם או ויתור של צד על זכות לפיו יהיו חסרי תוקף אלא אם ייעשו בכתב
				וייחתמו על ידי הצדדים. הימנעות או שיהוי של החברה ממימוש כל זכות העומדת
				לה לפי ההסכם לא ייחשבו כוויתור מצדה, ולא ימנעו ממנה כל פעולה למימוש
				זכויותיה, כולן או חלקן.
			</p>

			<p class="heading">הדין החל וסמכות שיפוט</p>
			<p class="p-margins">
				תנאי השימוש משקפים את כלל ההסכמות בין הצדדים בעניין תנאי השימוש במערכת
				והיחסים ביניהם, וגוברים על כל הסכמה או התחייבות קודמת, בעל-פה או בכתב.
				החברה רשאית להמחות, להעביר או להסב את זכויותיה, בכל עת, לפי שיקול דעתה
				הבלעדי, ולמשתמש לא תהיה כל טענה בקשר לכך.
			</p>
			<p class="p-margins">על תנאים אלה יחולו דיני מדינת ישראל.</p>
			<p class="p-margins">
				כל תביעה הנוגעת לתנאים אלה או נובעת מהם תוגש לבית המשפט המוסמך בעיר תל
				אביב, אשר יהיה בעל סמכות שיפוט ייחודית ובלעדית.
			</p>
			<p class="p-margins">
				במידה וייקבע שתנאי כלשהו מתנאי השימוש אינו תקף או שאינו בר-אכיפה על ידי
				בית משפט בעל סמכות, אזי התנאי שתוקפו נשלל או שאינו ניתן לאכיפה ייחשב
				כאילו הוחלף בתנאי תקף וניתן לאכיפה, שתוכנו תואם במידת הקירוב הגדולה
				ביותר את משמעות וכוונת התנאי המקורי, ויתר תנאי השימוש יישארו בתוקפם.
			</p>
			<p class="p-margins">
				המשתמש מודע ומסכים שבעצם ההרשמה לתוכנה והשימוש בה הוא מתחייב שלא להגיש
				ולא לסייע לצד שלישי להגיש כנגד החברה תובענה ייצוגית, וכי כל מחלוקת בינו
				לבין החברה תתברר בתובענה אישית בלבד.
			</p>

			<p class="heading">הודעות</p>
			<p class="p-margins">
				המשתמש מסכים שככל שהחברה תצטר ליצור עימו קשר, היא תוכל לעשות זאת לכל
				כתובת הידועה לחברה, לרבות באמצעות הטלפון, ווטסאפ, דואר אלקטרוני או מערכת
				מסרים אחרים.
			</p>

			<p class="p-margins">
				פניות לשירות הלקוחות תתבצע באמצעות הווטסאפ או המייל. במידת הצורך ולפי
				שיקול הדעת של החברה יתבצע שירות לקוחות טלפוני.
			</p>

			<p class="p-margins">
				הודעות אחרות על פי הסכם זה יימסרו לחברה בדואר רשום לכתובת ד"ר עמי אבני
				בע"מ, ק"מ 74, רמת החייל, תל אביב, 6927826
			</p>
		</div>
		<div>
			<br />
		</div>
		<div class="modal-btns">
			<app-btn-ext
				text="exit"
				(clickEv)="onClose.emit()"
			/>
			<button
				class="btn btn-primary"
				(click)="isPrivacyOpen = true"
			>
				{{ "privacy" | langVal }}
			</button>
		</div>
		@if (isPrivacyOpen) {
			<app-modal-wrap
				(onClose)="isPrivacyOpen = false"
				modalWrapperClass="modal-wide"
				hasExit
			>
				<app-privacy (onClose)="isPrivacyOpen = false" />
			</app-modal-wrap>
		}
	`,
})
export class TermsComponent extends Modalable {
	isPrivacyOpen: boolean = false
}
